var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDumyUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14059",
    "data-name": "Group 14059",
    transform: "translate(-1189 -11.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    transform: "translate(1189 11.5)",
    fill: "#ffec9f",
    stroke: "#ffd571",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1077012",
    "data-name": 1077012,
    transform: "translate(1200.214 20.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11961",
    "data-name": "Path 11961",
    d: "M96.026,4.5a4.35,4.35,0,0,1-1.317,3.179,4.35,4.35,0,0,1-3.179,1.317h0a4.351,4.351,0,0,1-3.176-1.317A4.349,4.349,0,0,1,87.035,4.5a4.349,4.349,0,0,1,1.317-3.178A4.349,4.349,0,0,1,91.528,0h0a4.351,4.351,0,0,1,3.179,1.317A4.35,4.35,0,0,1,96.026,4.5Zm0,0",
    transform: "translate(-83.862 0)",
    fill: "#fdb713"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11962",
    "data-name": "Path 11962",
    d: "M15.572,253.759a3.1,3.1,0,0,1-.921,2.345,3.313,3.313,0,0,1-2.372.865H3.292A3.312,3.312,0,0,1,.921,256.1,3.1,3.1,0,0,1,0,253.759c0-.375.012-.746.037-1.1a11.035,11.035,0,0,1,.151-1.18,9.31,9.31,0,0,1,.29-1.185,5.879,5.879,0,0,1,.487-1.106,4.186,4.186,0,0,1,.735-.958,3.242,3.242,0,0,1,1.056-.664A3.651,3.651,0,0,1,4.1,247.32a1.366,1.366,0,0,1,.73.309c.222.145.479.31.762.491a4.348,4.348,0,0,0,.984.434,3.925,3.925,0,0,0,1.085.193l.119,0a3.915,3.915,0,0,0,1.2-.195,4.348,4.348,0,0,0,.985-.434c.286-.183.542-.348.761-.491a1.365,1.365,0,0,1,.731-.31,3.653,3.653,0,0,1,1.348.244,3.244,3.244,0,0,1,1.056.664,4.171,4.171,0,0,1,.735.958,5.859,5.859,0,0,1,.487,1.106,9.3,9.3,0,0,1,.29,1.186,11.138,11.138,0,0,1,.151,1.179c.025.355.038.726.038,1.1Zm0,0",
    transform: "translate(0 -238.304)",
    fill: "#6aa9ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDumyUserIcon);
export default __webpack_public_path__ + "static/media/dumy-user-icon.59b62463a60c15d76e50f9047b09cd59.svg";
export { ForwardRef as ReactComponent };